module.exports = __webpack_public_path__ + "img/pge_logo.aba950b8.webp";